import React, { AnchorHTMLAttributes, FC } from "react";

import { Button, ButtonProps, useTheme } from "@mui/material";

type IgButtonProps = ButtonProps &
  Pick<AnchorHTMLAttributes<HTMLAnchorElement>, "rel" | "target">;

export const IgButton: FC<IgButtonProps> = (props) => {
  const theme = useTheme();
  const defaultProps = theme.components?.MuiButton?.defaultProps;

  const {
    children,
    onClick,
    loading,
    sx,
    variant = defaultProps?.variant,
    color = defaultProps?.color,
    startIcon,
    endIcon,
    ...rest
  } = props;

  return (
    <Button
      disableElevation
      loading={loading}
      startIcon={loading ? undefined : startIcon}
      endIcon={loading ? undefined : endIcon}
      sx={{
        ...(variant === "text" && {
          "& .MuiLoadingButton-loadingIndicator": {
            paddingRight: "50px",
          },
        }),
        ...sx,
      }}
      {...rest}
      variant={variant}
      color={color}
      onClick={Boolean(loading) && Boolean(onClick) ? undefined : onClick}
    >
      {!loading && children}
    </Button>
  );
};
